import moment from 'moment';
import laserCursor from 'assets/images/laser.svg';

export const shuffle = (array: any[]) => {
	let arrayCopy = [...array];
	let currentIndex = arrayCopy.length;
	let temporaryValue: any = undefined;
	let randomIndex = 0;

	while (0 !== currentIndex) {
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex -= 1;
		temporaryValue = arrayCopy[currentIndex];
		arrayCopy[currentIndex] = arrayCopy[randomIndex];
		arrayCopy[randomIndex] = temporaryValue;
	}

	return arrayCopy;
};

export const formatPostDate = (timestamp: Date): string => {
	if (!timestamp) {
		return '';
	}

	const givenDate = moment(timestamp).format('L');
	const today = moment().format('L');
	let date: string = '';
	switch (moment(moment(givenDate, 'MM/DD/YYYY')).diff(moment(today, 'MM/DD/YYYY'), 'days')) {
		case 0:
			date = 'Today';
			break;
		case -1:
			date = 'Yesterday';
			break;
		default:
			if (moment(timestamp).year() !== moment().year()) {
				date = moment(timestamp).format('MM/D/YYYY');
			} else {
				date = moment(timestamp).format('MM/D');
			}
	}

	const time = moment(timestamp).format('h:mm A');
	return `${date} at ${time}`;
};

export const modalRandomMovement = (event: any, enabled: boolean) => {
	if (!enabled) {
		return;
	}

	const actions: string[] = ['left', 'right', 'top', 'bottom'];
	const randomAction: string = actions[Math.floor(Math.random() * 4)];
	var icon = document.getElementById(event.target.id);
	var currentMovement: any = {};

	actions.forEach(action => {
		if (action === 'right' || action === 'top') {
			currentMovement[action] = parseInt((icon?.style as { [key: string]: any })[action] || 0);
		}
	});
	if (randomAction === 'bottom' && currentMovement['top'] + 50 > 450) {
		currentMovement['top'] -= 50;
	} else if (randomAction === 'left' && currentMovement['right'] + 50 > 360) {
		currentMovement['right'] -= 50;
	} else if (randomAction === 'right' && currentMovement['right'] - 50 < -360) {
		currentMovement['right'] += 50;
	} else if (randomAction === 'left') {
		currentMovement['right'] += 50;
	} else if (randomAction === 'bottom' || (randomAction === 'top' && currentMovement['top'] - 50 < -50)) {
		currentMovement['top'] += 50;
	} else {
		currentMovement[randomAction] -= 50;
	}

	if (!(icon?.style as { [key: string]: any })[randomAction] && (randomAction === 'right' || randomAction === 'top')) {
		icon?.setAttribute('style', `${randomAction}: 0px`);
	}

	actions.forEach(action => {
		if (action === 'top' || action === 'right') {
			const newMovement = currentMovement[action];
			(icon?.style as { [key: string]: any })[action] = `${newMovement}px`;
		}
	});
};

export const orderByProperty = (arr: any[], prop: string, ascending?: boolean) => {
	return arr
		? arr.sort(function (a, b) {
				// always send null or empty strings to the bottom of the list
				if (a[prop] === null || a[prop] === '') {
					return 1;
				} else if (b[prop] === null || b[prop] === '') {
					return -1;
				}

				let aProp: any, bProp: any;
				if (typeof a[prop] === 'string') {
					aProp = a[prop].toLowerCase().trim();
				} else {
					aProp = a[prop];
				}
				if (typeof b[prop] === 'string') {
					bProp = b[prop].toLowerCase().trim();
				} else {
					bProp = b[prop];
				}

				if (!ascending) {
					if (aProp < bProp) {
						return -1;
					}
					if (aProp > bProp) {
						return 1;
					}
				} else {
					if (aProp < bProp) {
						return 1;
					}
					if (aProp > bProp) {
						return -1;
					}
				}
				return 0; // default return value (no sorting)
		  })
		: null;
};

function positionEyes(verticalPosition: number, horizontalPosition: number, horizontalRightPosition?: number) {
	horizontalRightPosition = horizontalRightPosition ? horizontalRightPosition : horizontalPosition;
	const leftEye = document.querySelector('.left-eye') as HTMLElement;
	const rightEye = document.querySelector('.right-eye') as HTMLElement;

	leftEye.style.left = `${22 + horizontalPosition}px`;
	leftEye.style.top = `${3 + verticalPosition}px`;
	rightEye.style.left = `${41 + horizontalRightPosition}px`;
	rightEye.style.top = `${3 + verticalPosition}px`;
}

export const shiftCatEyes = (event: MouseEvent | TouchEvent) => {
	const catBox = document.getElementById('catBox') as HTMLDivElement;
	const parent = catBox.offsetParent as HTMLDivElement;
	const xPos = catBox.offsetWidth / 2 + catBox.offsetLeft + parent.offsetLeft;
	const yPos = catBox.offsetHeight / 2 + catBox.offsetTop + parent.offsetTop;

	var x = event instanceof TouchEvent ? event.touches[0].clientX : event.clientX;
	var y = event instanceof TouchEvent ? event.touches[0].clientY : event.clientY;
	let laserPointer = document.getElementById('laser-pointer');
	if (!laserPointer) {
		laserPointer = document.createElement('div');
		laserPointer.setAttribute('id', 'laser-pointer');
		laserPointer.style.width = '44px';
		laserPointer.style.height = '44px';
		laserPointer.style.position = 'fixed';
		laserPointer.style.zIndex = '999';
		laserPointer.style.backgroundImage = 'url(' + laserCursor + ')';
		document.getElementById('catBox')?.appendChild(laserPointer);
	}

	laserPointer.style.left = x - 22 + 'px';
	laserPointer.style.top = y - 22 + 'px';

	// top left
	if (x < xPos - 30 && y < yPos - 30) {
		positionEyes(-2, -2);
	}

	// between eyes up
	else if (x > xPos - 10 && x < xPos + 10 && y < yPos - 10 && y > yPos - 60) {
		positionEyes(-3, 3, -3);
	}

	// top middle
	else if (
		(x >= xPos - 30 && x <= xPos - 10 && y < yPos - 30) ||
		(x >= xPos + 10 && x <= xPos + 30 && y < yPos - 30) ||
		(x >= xPos - 30 && x <= xPos + 30 && y <= yPos - 60)
	) {
		positionEyes(-3, 0);
	}

	// top right
	else if (x > xPos + 30 && y < yPos - 30) {
		positionEyes(-2, 2);
	}

	// -------------------

	// center left
	else if (x < xPos - 30 && y < yPos + 5) {
		positionEyes(0, -4);
	}

	//between eyes
	else if (x >= xPos - 10 && x <= xPos + 10 && y <= yPos + 10 && y >= yPos - 10) {
		positionEyes(0, 4, -4);
	}

	// center middle
	else if (x < xPos + 30 && y < yPos + 5) {
		positionEyes(0, 0);
	}

	// center right
	else if (x > xPos + 30 && y < yPos + 5) {
		positionEyes(0, 4);
	}

	// -------------------

	// bottom left
	else if (x <= xPos - 30 && y >= yPos + 5) {
		positionEyes(3, -3);
	}

	// between eyes down
	else if (x >= xPos - 10 && x <= xPos + 10 && y >= yPos + 10 && y <= yPos + 60) {
		positionEyes(3, 3, -3);
	}

	// bottom middle
	else if (
		(x >= xPos - 30 && x <= xPos - 10 && y > yPos + 30) ||
		(x >= xPos + 10 && x <= xPos + 30 && y > yPos + 30) ||
		(x >= xPos - 30 && x <= xPos + 30 && y >= yPos + 60)
	) {
		positionEyes(3, 0);
	}
	// bottom right
	else if (x > xPos + 30 && y > yPos + 5) {
		positionEyes(4, 2);
	}
};
